import { render } from "./Heart.vue?vue&type=template&id=5db0980b"
import script from "./Heart.vue?vue&type=script&lang=js"
export * from "./Heart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Sources/JavaScript/Extensions/Components/Heart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5db0980b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5db0980b', __exports__)) {
    api.reload('5db0980b', __exports__)
  }
  
  module.hot.accept("./Heart.vue?vue&type=template&id=5db0980b", () => {
    api.rerender('5db0980b', render)
  })

}


export default __exports__